import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import DataFlowService from '../../services/DataFlow.service';
import RopaService from '../../services/Ropa.service';
import Dashboard4 from './Dashboard4';
import Dashboard3 from './Dashboard3';
import Dashboard2 from './Dashboard2';
import Dashboard1 from './Dashboard1';
import UserService from '../../services/UserService';
import Dataflow from './components/Dataflow';
import Ropa from './components/Ropa';
import { Spin } from 'antd';

export default function Dashboard() {
    const { t } = useTranslation();
    const [ropaSummary, setRopaSummary] = useState();
    const [mDepartment, setMDepartment] = useState([]);
    const [dataflowSummary, setDataflowSummary] = useState();

    // Loading
    const [isLoading, setIsLoading] = useState(false);
    const [loadingDataflow, setLoadingDataflow] = useState(false);
    const [isLoadingDepartment, setIsLoadingDepartment] = useState(false);

    // Role
    const role = UserService.role().toLowerCase();
    const admin = ['admin', 'auditor', 'super admin'].includes(role);

    useEffect(() => {
        getDepartmentList();
        getRopaList();
        getSummary();
    }, []);

    const getDepartmentList = async () => {
        try {
            setIsLoadingDepartment(true);
            const { data } = await DataFlowService.getDepartmentList();
            if (data?.resultData) {
                setIsLoadingDepartment(false);
                setMDepartment(data.resultData);
            }
        } catch (error) {
            setIsLoadingDepartment(false);
            console.log(error);
        }
    };

    const getSummary = async () => {
        setLoadingDataflow(true);
        try {
            const { data } = await DataFlowService.getSummary();
            if (data?.resultData) {
                setLoadingDataflow(false);
                setDataflowSummary(data.resultData);
            } else {
                setLoadingDataflow(false);
            }
        } catch (error) {
            setLoadingDataflow(false);
            console.log(error);
        }
    };

    const getRopaList = async () => {
        try {
            setIsLoading(true);
            const { data } = await RopaService.getRopaList();
            if (data?.resultData) {
                setIsLoading(false);
                setRopaSummary(data.resultData);
            } else {
                setIsLoading(false);
            }
        } catch (error) {
            setIsLoading(false);
            console.log(error);
        }
    };

    return (
        <div>
            <div className="title ">{t('common.Dashboard')}</div>
            <div className="sub-title">
                <span className="text-sm text-gray-400">
                    {t('Data Inventory')} /{' '}
                </span>
                <span> {t('common.Dashboard')}</span>
            </div>
            <div className="my-6 py-4 px-6 bg-white rounded-md">
                <span className="text-xl text-purple font-semibold">
                    {t('Data Inventory Dashboard')}
                </span>
            </div>

            <div className="grid grid-cols-12 mt-4">
                <div className="col-span-4 bg-white rounded-md mr-4 p-6">
                    <Spin spinning={loadingDataflow}>
                        <Dataflow summary={dataflowSummary} />
                    </Spin>
                </div>
                <div className="col-span-4 bg-white rounded-md mr-4 p-6">
                    <Spin spinning={isLoading}>
                        <Ropa summary={ropaSummary} />
                    </Spin>
                </div>
                <div className="col-span-4">
                    <Dashboard1
                        summary={dataflowSummary}
                        ropaList={ropaSummary}
                        isLoading={isLoading}
                    />
                </div>
            </div>

            {admin && (
                <div className="grid grid-cols-12 mt-4">
                    <div className="col-span-6 bg-white rounded-md mr-2">
                        <div className="p-6">
                            <Dashboard3
                                mDepartment={mDepartment}
                                admin={admin}
                                isLoading={isLoadingDepartment}
                            />
                        </div>
                    </div>
                    <div className="col-span-6 bg-white rounded-md ml-2">
                        <div className="p-6">
                            <Dashboard4
                                mDepartment={mDepartment}
                                admin={admin}
                                isLoading={isLoadingDepartment}
                            />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
